import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Common from "../based/Common";
import { CONSTANTS, NOTIFY, PLATFORM, STATUS_ACTIVE } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import { SwichToogle } from "../based/inputs/SwitchToogle";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import AccountServices from "../based/services/AccountServices";
import PlatformServices from "../based/services/PlatformServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import SpxLogo from "./assets/SpxLogo.svg";
import TelegramLogo from "./assets/TelegramLogo.svg";
import TiktokLogo from "./assets/TiktokLogo.svg";
import GroupNotiModal from "./GroupNotiModal";

const PlatformEnum = {
    Tiktok: 1,
    Telegram: 2,
    SPX: 3,
};

const TelegramType = {
    Account: 1,
    Group: 2,
};

function ConnectPlatformConfig(props) {
    const [stores, setStores] = useState([]);
    const [isBusy, setBusy] = useState(false);
    const history = useHistory();
    //telegram
    const [tabId, setTabId] = useState(PlatformEnum.Tiktok);
    const [agencyModel, setAgencyModel] = useState({});
    const [lstConnect, setLstConnect] = useState([]);
    const [typeId, setTypeId] = useState(TelegramType.Account); //1: thông báo qua tài khoản, 2: thông báo theo nhóm
    const [groupModal, setGroupModal] = useState(false);
    //telegram group
    const [groupTypeOptions, setGroupTypeOptions] = useState([]);
    //spx
    const [spxAccount, setSpxAccount] = useState(null);
    const [spxPhone, setSpxPhone] = useState("");
    const [spxEmail, setSpxEmail] = useState("");

    useEffect(() => {
        connnect();
    }, []);

    useEffect(() => {
        if (tabId == PlatformEnum.Telegram) {
            getAgencyModel();
            getLstConnect();
        }
        if (tabId == PlatformEnum.SPX) {
            getAgencyModel();
            getSpxAccount();
        }
    }, [tabId]);

    useEffect(() => {
        if (typeId == TelegramType.Group) getListGroupType();
    }, [typeId]);

    //mặc định lấy số điện thoại/email của user để tạo tài khoản SPX
    useEffect(() => {
        if (tabId == PlatformEnum.SPX && !spxAccount && agencyModel && agencyModel.user) {
            if (!spxPhone) setSpxPhone(agencyModel.user.phoneNumber || "");
            if (!spxEmail) setSpxEmail(agencyModel.user.email || "");
        }
    }, [agencyModel, tabId, spxAccount]);

    async function connnect() {
        let fullParamUrl = window.location.search;
        if (fullParamUrl && fullParamUrl.indexOf("code=") > -1) {
            setBusy(true);
            const [err, data] = await PlatformServices.ConnectToPlatform(fullParamUrl + `&platform=${PLATFORM.Tiktok}`);
            if (!err) {
                setBusy(false);
                history.push("/connect-platform-config/tiktok");
            } else {
                if (err.data) Notify(NOTIFY.ERROR, "Lỗi", err.data);
                else Notify(NOTIFY.ERROR, "Lỗi", CONSTANTS.MSG_ERROR);
                setBusy(false);
                history.push("/connect-platform-config/tiktok");
            }
        }

        //lấy thông tin cửa hàng
        _getStores();
    }

    async function _handleConnect() {
        setBusy(true);
        const [err, resdata] = await PlatformServices.ConnectToPlatform(`?platform=${PLATFORM.Tiktok}`);
        if (!err) {
            window.location.href = resdata;
        }
        setBusy(false);
    }

    async function _getStores() {
        setBusy(true);
        const [err, data] = await PlatformServices.PlatformStoresUser([PLATFORM.Tiktok], STATUS_ACTIVE.All);
        if (!err) {
            setStores(data);
        } else {
            setStores([]);
        }
        setBusy(false);
    }

    async function _handleActiveStore(platform, shop, isActive) {
        const [err, data] = await PlatformServices.UpdateSetIsActiveShop(platform, shop, isActive);
        if (!err) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Cập nhật trạng thái gian hàng thành công");
            _getStores();
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Cập nhật trạng thái gian hàng thất bại");
        }
    }

    const getListGroupType = async () => {
        const [err, data] = await AccountServices.GetGroupTelegramByPartner();
        if (!err && data) {
            const dt = data.filter((x) => x.groupId != 0);
            setGroupTypeOptions(dt);
        } else {
            setGroupTypeOptions([]);
        }
    };

    async function getAgencyModel() {
        const [err, data] = await AccountServices.GetAgencyUserByUserId();
        if (!err) {
            setAgencyModel(data);
        } else {
            setAgencyModel({});
        }
    }

    async function getLstConnect() {
        const [err, data] = await AccountServices.GetAgencyTelegramByPartner();
        if (!err) {
            setLstConnect(data);
        } else {
            setLstConnect([]);
        }
    }

    async function getSpxAccount() {
        setBusy(true);
        const [err, data] = await PlatformServices.GetSpxAccount();
        if (!err && data) {
            setSpxAccount(data);
            setSpxPhone(data.phone || "");
            setSpxEmail(data.email || "");
        } else {
            setSpxAccount(null);
        }
        setBusy(false);
    }

    async function _handleCreateSpxAccount() {
        const phone = (spxPhone || "").trim();
        const email = (spxEmail || "").trim();
        //ràng buộc theo tài liệu SPX: phone bắt buộc tối đa 32, email không bắt buộc tối đa 64
        if (!phone) {
            Notify(NOTIFY.WARNING, "Chú ý", "Vui lòng nhập số điện thoại để tạo tài khoản SPX");
            return;
        }
        if (phone.length > 32) {
            Notify(NOTIFY.WARNING, "Chú ý", "Số điện thoại không được vượt quá 32 ký tự");
            return;
        }
        if (email && email.length > 64) {
            Notify(NOTIFY.WARNING, "Chú ý", "Email không được vượt quá 64 ký tự");
            return;
        }
        setBusy(true);
        const [err, data] = await PlatformServices.CreateSpxAccount(phone, email);
        if (!err && data) {
            setSpxAccount(data);
            setSpxPhone(data.phone || "");
            setSpxEmail(data.email || "");
            //tài khoản đã có sẵn thì báo cho user biết thay vì báo tạo mới thành công
            if (data.isExisted) Notify(NOTIFY.WARNING, "Chú ý", "Bạn đã có tài khoản SPX, hệ thống hiển thị lại thông tin tài khoản hiện có");
            else Notify(NOTIFY.SUCCESS, "Thành công", "Tạo tài khoản SPX thành công");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", err && err.data ? err.data : CONSTANTS.MSG_ERROR);
        }
        setBusy(false);
    }

    async function _handleVerifySpxAccount() {
        setBusy(true);
        const [err, data] = await PlatformServices.VerifySpxAccount();
        if (err) {
            Notify(NOTIFY.ERROR, "Lỗi", err.data ? err.data : CONSTANTS.MSG_ERROR);
        } else if (data === true) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Tài khoản SPX hợp lệ");
        } else {
            Notify(NOTIFY.WARNING, "Chú ý", "Tài khoản SPX không hợp lệ, vui lòng liên hệ SPX để kiểm tra lại");
        }
        setBusy(false);
    }

    async function removeConnectTelegram(id) {
        const [err, data] = await AccountServices.RemoveConnectTelegram(id);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Xóa kết nối thành công");
            getLstConnect();
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", err.data ? err.data : CONSTANTS.MSG_ERROR);
        }
    }

    async function _handleRemoveStore(id) {
        ConfirmDialog("Xác nhận", "Bạn chắc chắn muốn xóa kết nối đến gian hàng đã chọn? ", () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true);
                const [err, data] = await PlatformServices.DeleteConnectStore(id);
                if (!err) {
                    if (data) {
                        resolve({ title: "Thành công", msg: "Xóa kết nối gian hàng thành công" });
                        let storesUpdate = [...stores];
                        let idx = -1;
                        storesUpdate.map((item, i) => {
                            if (item.id == id) idx = i;
                        });
                        if (idx > -1) storesUpdate.splice(idx, 1);
                        setStores(storesUpdate);
                    } else {
                        reject(err);
                    }
                } else {
                    Notify(NOTIFY.ERROR, "Lỗi", CONSTANTS.MSG_ERROR);
                }
                setBusy(false);
            });
        });
    }

    async function removeTelegramGroup(id) {
        const [err, data] = await AccountServices.RemoveTelegramGroup(id);
        if (!err && data) {
            getListGroupType();
            Notify(NOTIFY.SUCCESS, "Thành công", "Xóa nhóm thông báo thành công");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", err.data ? err.data : CONSTANTS.MSG_ERROR);
        }
    }

    async function handleRefreshToken(store) {
        ConfirmDialog("Xác nhận", "Bạn chắc chắn muốn kết nối lại gian hàng đã chọn? ", () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true);
                const [err, data] = await PlatformServices.RefreshAccessToken({ id: store.id, shopId: store.shopId, platform: PLATFORM.Tiktok });
                if (!err) {
                    resolve({ title: "Thành công", msg: "Kết nối gian hàng thành công" });
                    _getStores();
                } else {
                    reject({ title: "Có lỗi", msg: err.data ? err.data : CONSTANTS.MSG_ERROR });
                }
                setBusy(false);
            });
        });
    }

    return (
        <React.Fragment>
            <Breadcum
                options={[
                    { label: "Trang chủ", value: "/" },
                    { label: "Cài đặt kênh bán hàng", value: "/connect-platform-config" },
                ]}
                title="Cài đặt kênh bán hàng"
            />
            <Loading show={isBusy} msg={"Đang xử lý dữ liệu"} />
            <Wrapper>
                <section className="platform-header">
                    <div className="list-platform">
                        <div
                            className={`platform-item ${tabId == PlatformEnum.Tiktok ? "active" : ""}`}
                            onClick={(e) => {
                                setTabId(PlatformEnum.Tiktok);
                            }}
                        >
                            <div className="logo-platform">
                                <img src={TiktokLogo} alt="tiktok" />
                            </div>
                        </div>
                        <div
                            className={`platform-item ${tabId == PlatformEnum.Telegram ? "active" : ""}`}
                            onClick={(e) => {
                                setTabId(PlatformEnum.Telegram);
                            }}
                        >
                            <div className="logo-platform">
                                <img src={TelegramLogo} alt="telegram" />
                            </div>
                            <div className="logo-detail">
                                <strong>Nhận thông báo</strong>
                                <sub>Đơn hàng/hàng hoàn</sub>
                            </div>
                        </div>
                        <div
                            className={`platform-item ${tabId == PlatformEnum.SPX ? "active" : ""}`}
                            onClick={(e) => {
                                setTabId(PlatformEnum.SPX);
                            }}
                        >
                            <div className="logo-platform">
                                <img src={SpxLogo} alt="spx" />
                            </div>
                            <div className="logo-detail">
                                <strong>SPX Express</strong>
                                <sub>Tạo tài khoản vận chuyển</sub>
                            </div>
                        </div>
                    </div>
                </section>
                {tabId == PlatformEnum.Tiktok && (
                    <section className="platform-body">
                        <div className="body-instruction">
                            <p>
                                Lưu ý: Chọn phương thức lấy hàng trên Tiktokshop là: “Gửi hàng”. Sau khi sản xuất xong, Ranus sẽ tự giao ra bưu cục.
                                <br />
                                <span className="high-light">
                                    Hướng dẫn thay đổi phương thức lấy hàng
                                    <i className="fa fa-chevron-right"></i>
                                </span>
                            </p>
                        </div>
                        <div className="list-action">
                            <button
                                className="btn btn-orange"
                                onClick={(e) => {
                                    _handleConnect();
                                }}
                            >
                                <span>
                                    Liên kết bán hàng <i className="fa fa-plus"></i>
                                </span>
                            </button>
                        </div>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th className="center">Mã gian hàng</th>
                                    <th className="center">Tên gian hàng</th>
                                    <th className="center">Ngày kết nối</th>
                                    <th className="center">Ngày hết hạn</th>
                                    <th className="center">Trạng thái</th>
                                    <th className="center">Kích hoạt</th>
                                    <th className="center">Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stores && stores.length > 0 ? (
                                    stores.map((store, k) => {
                                        return (
                                            <tr key={k}>
                                                <td className="center">{store.shopId}</td>
                                                <td className="center">{store.shopName}</td>
                                                <td className="center">{store.connectDate}</td>
                                                <td className="center">{store.connectDateExpires}</td>
                                                <td className="center">
                                                    {store.isExpired ? (
                                                        <React.Fragment>
                                                            <span className="badge badge-danger">Hết hạn</span>
                                                            <span className="refresh-token cursor-pointer" onClick={() => handleRefreshToken(store)}>
                                                                <i className="fa fa-refresh"></i>
                                                                Kết nối lại
                                                            </span>
                                                        </React.Fragment>
                                                    ) : (
                                                        <span className="badge badge-custom">Đang hoạt động</span>
                                                    )}
                                                </td>
                                                <td className="center">
                                                    <SwichToogle
                                                        value={store.isActive}
                                                        onCheckChanged={(name, value) => {
                                                            _handleActiveStore(PLATFORM.Tiktok, store.shopId, value);
                                                        }}
                                                    />
                                                </td>
                                                <td className="center">
                                                    <div className="list-action-store">
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                if (store.platform == PLATFORM.Tiktok) {
                                                                    history.push(`/edit-shop-tiktok/${store.id}`);
                                                                }
                                                            }}
                                                        >
                                                            <span>
                                                                <i className="fa fa-gear"></i>
                                                                Cài đặt
                                                            </span>
                                                        </a>
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                _handleRemoveStore(store.id);
                                                            }}
                                                        >
                                                            <span>
                                                                <i className="fa fa-trash"></i>
                                                                Xóa
                                                            </span>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={100}>Không có dữ liệu</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </section>
                )}
                {tabId == PlatformEnum.Telegram && (
                    <React.Fragment>
                        <section className="platform-type">
                            <div className="list-type">
                                <div className={`type-item ${typeId == TelegramType.Account ? "active" : ""}`} onClick={(e) => setTypeId(TelegramType.Account)}>
                                    <span>Thông báo qua tài khoản</span>
                                </div>
                                <div className={`type-item ${typeId == TelegramType.Group ? "active" : ""}`} onClick={(e) => setTypeId(TelegramType.Group)}>
                                    <span>Thông báo theo nhóm</span>
                                </div>
                            </div>
                        </section>
                        {typeId == TelegramType.Group && (
                            <React.Fragment>
                                <section className="platform-body group-type">
                                    <div className="instruction">
                                        <p>Tính năng giúp bạn và các thành viên nhận các thông báo theo từng nhóm, từng mục đích khác nhau (Nhóm Đơn hàng mới/Đơn hoàn hàng/...)</p>
                                    </div>
                                    <button
                                        className="btn btn-orange"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setGroupModal(true);
                                        }}
                                    >
                                        <span>
                                            Tạo nhóm
                                            <i className="fa fa-plus"></i>
                                        </span>
                                    </button>
                                    <h6>Danh sách nhóm</h6>
                                    <section className="table-group">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <td>Tên nhóm</td>
                                                    <td>Loại nhóm</td>
                                                    <td>Thời gian tạo</td>
                                                    <td>Thao tác</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {groupTypeOptions && groupTypeOptions.length > 0 ? (
                                                    groupTypeOptions.map((item, idx) => {
                                                        return (
                                                            <tr key={idx}>
                                                                <td>{item.name}</td>
                                                                <td>{item.groupTypeName}</td>
                                                                <td>{item.createdDate != null && Common.formatDate(new Date(item.createdDate))}</td>
                                                                <td className="center">
                                                                    <a
                                                                        href="#"
                                                                        className="text text-danger"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            removeTelegramGroup(item.id);
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            <i className="fa fa-trash"></i> Xóa
                                                                        </span>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={999}>Không có dữ liệu</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </section>
                                </section>
                            </React.Fragment>
                        )}
                        {typeId == TelegramType.Account && (
                            <React.Fragment>
                                <section className="platform-body">
                                    <div className="instruction">
                                        <p>Kết nối Telegram RanusPartner để được cập nhật các thông báo về đơn hàng/đẩy sản phẩm..., theo các bước:</p>
                                        <p>Bước 1: Nhấn vào “Kết nối” hoặc “Copy link” chia sẻ cho các thành viên để kết nối với Botchat Ranus trên Telegram</p>
                                        <div className="barcode-section">
                                            <div className="link-code">
                                                <a
                                                    href=""
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        navigator.clipboard.writeText(`https://t.me/RanusPartnerBot?start=${agencyModel.telegramCode}`);
                                                        Notify(NOTIFY.SUCCESS, "Thành công", "Copy link thành công");
                                                    }}
                                                >
                                                    {`https://t.me/RanusPartnerBot?start=${agencyModel.telegramCode}`}
                                                </a>
                                                <button
                                                    className="copy-link btn"
                                                    onClick={(e) => {
                                                        navigator.clipboard.writeText(`https://t.me/RanusPartnerBot?start=${agencyModel.telegramCode}`);
                                                        Notify(NOTIFY.SUCCESS, "Thành công", "Copy link thành công");
                                                    }}
                                                >
                                                    <span>
                                                        <i className="fa fa-copy"></i> Copy Link
                                                    </span>
                                                </button>
                                            </div>
                                            <button
                                                className="connect-link btn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    window.open(`https://t.me/RanusPartnerBot?start=${agencyModel.telegramCode}`, "_blank");
                                                }}
                                            >
                                                <span>
                                                    <i className="fa fa-connectdevelop"></i> Kết nối
                                                </span>
                                            </button>
                                        </div>
                                        <p>Bước 2: Nhấn vào “Start Bot” để kết nối</p>
                                    </div>
                                </section>
                                <section className="table">
                                    <h6>Tài khoản Telegram đã kết nối</h6>
                                    <table className="table table-bordered">
                                        <thead>
                                            <th className="center">Tài khoản</th>
                                            <th className="center">Thời gian kết nối</th>
                                            <th className="center">Thao tác</th>
                                        </thead>
                                        <tbody>
                                            {lstConnect && lstConnect.length > 0 ? (
                                                lstConnect.map((item, idx) => {
                                                    return (
                                                        <tr>
                                                            <td className="vertical-align-middle">{item.name}</td>
                                                            <td className="center">{Common.formatDate(new Date(item.createdDate))}</td>
                                                            <td className="center">
                                                                <a
                                                                    href=""
                                                                    className="text text-danger"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        ConfirmDialog(
                                                                            "Xóa",
                                                                            "Bạn có muốn xóa",
                                                                            new Promise((resolve, reject) => {
                                                                                removeConnectTelegram(item.id);
                                                                            })
                                                                        );
                                                                    }}
                                                                >
                                                                    <span>
                                                                        <i className="fa fa-trash"></i> Xóa
                                                                    </span>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={999}>Không có dữ liệu</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </section>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
                {tabId == PlatformEnum.SPX && (
                    <section className="platform-body spx-type">
                        <div className="instruction">
                            <p>Tạo tài khoản SPX Express để sử dụng dịch vụ vận chuyển của Shopee Xpress cho các đơn hàng của bạn.</p>
                            <p>Nhập số điện thoại đăng ký, nhấn “Tạo tài khoản”. Hệ thống sẽ tạo tài khoản trên SPX và lưu lại thông tin kết nối.</p>
                        </div>
                        {spxAccount ? (
                            <React.Fragment>
                                <h6>Tài khoản SPX đã kết nối</h6>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="center">Số điện thoại</th>
                                            <th className="center">Email</th>
                                            <th className="center">User ID</th>
                                            <th className="center">Ngày tạo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="center">{spxAccount.phone}</td>
                                            <td className="center">{spxAccount.email}</td>
                                            <td className="center">{spxAccount.spxUserId}</td>
                                            <td className="center">{spxAccount.createdDate && Common.formatDate(new Date(spxAccount.createdDate))}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <button
                                    className="btn btn-orange"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        _handleVerifySpxAccount();
                                    }}
                                >
                                    <span>
                                        Kiểm tra kết nối
                                        <i className="fa fa-refresh"></i>
                                    </span>
                                </button>
                            </React.Fragment>
                        ) : (
                            <div className="spx-create">
                                <div className="form-group">
                                    <label>
                                        Số điện thoại <span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nhập số điện thoại"
                                        maxLength={32}
                                        value={spxPhone}
                                        onChange={(e) => setSpxPhone(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nhập email (không bắt buộc)"
                                        maxLength={64}
                                        value={spxEmail}
                                        onChange={(e) => setSpxEmail(e.target.value)}
                                    />
                                </div>
                                <button
                                    className="btn btn-orange"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        _handleCreateSpxAccount();
                                    }}
                                >
                                    <span>
                                        Tạo tài khoản
                                        <i className="fa fa-plus"></i>
                                    </span>
                                </button>
                            </div>
                        )}
                    </section>
                )}
            </Wrapper>
            <GroupNotiModal
                show={groupModal}
                onClose={() => {
                    setGroupModal(false);
                }}
                onSave={() => {
                    setGroupModal(false);
                    getListGroupType();
                }}
            />
        </React.Fragment>
    );
}

export default ConnectPlatformConfig;

const Wrapper = styled.div`
    width: 90%;
    overflow: hidden;

    .link-code a {
        word-wrap: break-word;
    }

    button.copy-link.btn {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    button.connect-link.btn {
        background: #37aee2;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    section.platform-type {
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    .instruction p {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin-bottom: 6px;
    }

    .barcode-section {
        display: flex;
        align-items: center;
        margin: 6px 0;
    }

    .link-code {
        margin-right: 6px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .link-code a {
        padding: 0 10px 0 16px;
    }

    .link-code button {
        border-radius: 0 !important;
    }

    span.refresh-token {
        color: #d70000;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 3px 5px;
        margin-left: 4px;
    }

    span.refresh-token i {
        margin-right: 4px;
    }

    .list-action-store span {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: center;
    }

    .list-action-store span i {
        margin-right: 6px;
    }

    .list-action-store a {
        display: flex;
        margin: 8px 0;
    }

    .list-action-store {
        display: flex;
        flex-direction: column;
    }

    section.platform-header {
    }

    .list-platform {
        display: flex;
    }

    .body-instruction p {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    span.high-light {
        color: #ff9027;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 153.846% */
        display: flex;
        align-items: baseline;
        margin-top: 8px;
    }

    span.high-light i.fa.fa-chevron-right {
        display: flex;
        margin-left: 6px;
    }

    .list-action {
        display: flex;
        margin: 24px 0;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
    }

    button.btn.btn-orange span {
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: baseline;
    }

    button.btn.btn-orange span i {
        margin-left: 6px;
    }

    .platform-item {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .logo-detail {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 4px;
    }

    .logo-detail strong {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .logo-detail sub {
        color: #707070;
        font-family: Lexend;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    section.platform-body {
        background: white;
        padding: 10px 16px;
    }

    .platform-item {
        padding-bottom: 13px;
        min-width: 100px;
        justify-content: center;
        margin-right: 20px;
    }

    .platform-item.active {
        border-bottom: 2px solid #ff9027;
    }

    .list-type {
        display: flex;
        align-items: center;
    }

    section.platform-type {
        background: white;
        padding: 10px;
    }

    .type-item {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 12px 18px;
        cursor: pointer;
    }

    .type-item.active {
        border-radius: 8px;
        background: #fff5ec;
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    section.table {
        border: 1px solid #f3f3f3;
        background: #fff;
        margin: 12px 0;
        padding: 24px;
    }

    section.table h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .table thead {
        border-radius: 8px 8px 0px 0px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
    }

    section.table table.table.table-bordered {
        width: 50%;
    }

    section.platform-body.group-type h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    section.table-group {
        width: 60%;
    }

    section.platform-body.group-type .btn-orange {
        margin: 12px 0;
    }

    section.platform-body.spx-type h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 16px 0 12px 0;
    }

    section.platform-body.spx-type .spx-create {
        margin: 16px 0;
    }

    section.platform-body.spx-type .spx-create .form-group {
        max-width: 320px;
        margin-bottom: 12px;
    }

    section.platform-body.spx-type .spx-create label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 6px;
    }

    section.platform-body.spx-type table.table.table-bordered {
        width: 80%;
    }

    section.platform-body.spx-type table.table.table-bordered + .btn-orange {
        margin-top: 12px;
    }

    section.platform-body.spx-type .spx-create label .required {
        color: #d70000;
    }

`;
